import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { GlobalProvider } from './utils/GlobalState.js';
import { LanguageProvider } from './contexts/LanguageContext.js';
import { getAuthToken } from './utils/auth';
import Login from './components/Auth/Login';
import Welcome from './components/Auth/Welcome';
import Dashboard from './components/Dashboard';
import ProtectedRoute from './utils/ProtectedRoute';
import Management from './components/AccountManagement/Management.js';
import TemplateManagement from './components/AccountManagement/TemplateManagement.js';
import PhotoManagement from './components/AccountManagement/PhotoManagement.js';
import PhotoReviewOBMExpert from './components/AccountManagement/PhotoReviewOBMExpert.js';
import AccountManagement from './components/AccountManagement/AccountManagement';
import Account from './components/AccountManagement/Account.js';
import AccountInformation from './components/AccountManagement/AccountInformation';
import CreateAccountForm from './components/AccountManagement/CreateAccountForm';
import ImportAccount from './components/AccountManagement/ImportAccountList.js';
import ChangePassword from './components/AccountManagement/ChangePassword.js';
import UpdatePassword from './components/AccountManagement/UpdatePassword.js';
import Profile from './components/Auth/Profile.js';
import ProductInfoInput from './components/GoodPerformance/ProductInfoInput.js';
import PerformanceRecording from './components/GoodPerformance/PerformanceRecording.js';
import AIODSImageViewer from './components/AIOpticalDetectionSystemAIODS/AIOpticalDetectionSystemAIODS.js';
import ProductInfo from './components/MuraLabeling/ProductInfo';
import UploadPhoto from './components/MuraLabeling/UploadPhoto';
import MuraRootCauseDetail from './components/MuraLabeling/MuraRootCauseDetail';
import MuraRootCauseLabeling from './components/MuraLabeling/MuraRootCauseLabeling.js';
import MarkDefectRegion from './components/MuraLabeling/MarkDefectRegion';
import MuraLabeling from './components/MuraLabeling/MuraLabeling.js';
import { ComingSoonLL, ComingSoonAID } from './components/ComingSoon/ComingSoon.js'
import LLProductInfoInput from './components/LightLeakage/LLProductInfoInput.js';
import LLDetectorCamera from './components/LightLeakage/LLDetectorCamera.js'
import LightLeakageLabeling from './components/LightLeakage/LightLeakageLabeling.js';
import FullscreenInspectionView from './components/LightLeakage/FullscreenInspectionView.js';
import LightLeakageRootCauseLabeling from './components/LightLeakage/LightLeakageRootCauseLabeling.js';
import UploadImage from './components/MuraIssueDetection/UploadImage.js';
import AgreeJudgement from './components/MuraIssueDetection/AgreeJudgement.js';
import DisagreeJudgement from './components/MuraIssueDetection/DisagreeJudgement.js';
import ReLabeling from './components/MuraIssueDetection/Relabeling.js'
import MarkRelabelingRegion from './components/MuraIssueDetection/MarkRelabelingregion.js'
import IssueRootCauseLabeling from './components/MuraIssueDetection/IssueRootCauseLabeling.js';
import IssueRootCauseDetail from './components/MuraIssueDetection/IssueRootcauseDetail.js';
import ProductInfoDetection from './components/MuraIssueDetection/productinfodetection.js';
import DefectPhotos from './components/StatisticsAndAnalysis/PhotoGallery.js';
import PhotoReview from './components/StatisticsAndAnalysis/PhotoReview.js';
import StatisticsAndAnalysis from './components/StatisticsAndAnalysis/StatisticsAndAnalysis.js';
import AudioAnalysis from './components/AudioAnalysis/AudioAnalysis.js';
import HWChangeVerification from './components/HardwareChangeVerification/HardwareChangeVerification.js';
import AssessmentDetail from './components/HardwareChangeVerification/AssessmentDetail.js';
import ImportChangeList from './components/HardwareChangeVerification/ImportList.js';
import VerificationReview from './components/HardwareChangeVerification/VerificationReview.js';
import { AssessmentProvider } from './components/HardwareChangeVerification/AssessmentContext.js';
import AudioCalibrationTool from './components/AudioIssueVisualization/AudioCalibaration.js';
import Calibration from './components/AudioIssueVisualization/AudioRecCalibration.js';
import AudioBuzzDetection from './components/AudioIssueVisualization/AudioBuzzDetection.js';
import AudioVerification from './components/AudioIssueVisualization/AudioVerification.js';
import AudioBuzzManagement from './components/AccountManagement/ABDataManagement.js';
import AudioIssueVisaualization from './components/AccountManagement/AudioIssueVisualization.js';
import ReviewRecordTable from './components/AccountManagement/AudioReviewRecord.js';
import ImportData from './components/AccountManagement/ImportData.js';
import AudioSpectrogram from './components/AccountManagement/AudioSpectrogram.js';
import { AudioDataProvider } from './components/AudioIssueVisualization/AudioContext.js';
import { SWChangeVerificationAssessment } from './components/ComingSoon/ComingSoon.js';
import { ProjectReportingHub } from './components/ComingSoon/ComingSoon.js';
import { VendorCapability } from './components/ComingSoon/ComingSoon.js';
import Certification from './components/Certification/Certification.js';
import MonitorControlTable from './components/Certification/MonitorControlTable.js';
import Certificationdetails from './components/HardwareChangeVerification/CertificationDetails.js';
import Certificationoverview from './components/HardwareChangeVerification/CertificationOverview.js';



const env = process.env.REACT_APP_ENVIRONMENT;
console.log("ENVIRONMENT->", process.env.REACT_APP_ENVIRONMENT);


function App() {
  const isAuthenticated = getAuthToken();

  return (
    <LanguageProvider>
    <GlobalProvider>
       <AssessmentProvider>
          <AudioDataProvider>
    <HashRouter>
      <Routes>
        <Route 
          path="/" 
          element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Welcome />} 
        />
        <Route 
          path="/login" 
          element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />} 
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/change-password/:email"
          element={
            <ProtectedRoute>
              <ChangePassword />
            </ProtectedRoute>
          }
        />
        <Route
          path="/update-password/:email"
          element={
            <ProtectedRoute>
              <UpdatePassword />
            </ProtectedRoute>
          }
        />
      <Route
          path="/profile/:email"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/management"
          element={
            <ProtectedRoute anyOfPermissions={['Management', 'templateManagement', 'photoManagement','audiobuzzManagement']}>
              <Management />
            </ProtectedRoute>
          }
        />
        <Route
          path="/account-management"
          element={
            <ProtectedRoute requiredPermission="Management">
              <Account />
            </ProtectedRoute>
          }
        >
          <Route index element={<AccountManagement />} />
          <Route path="information/:id" element={<AccountInformation />} />
          <Route path="create" element={<CreateAccountForm />} />
          <Route path="importlist" element={<ImportAccount />} />
          <Route path="templates" element={<TemplateManagement />} />
        </Route>
        <Route
          path="/templates" 
          element={
            <ProtectedRoute requiredPermission="templateManagement">
              <TemplateManagement />
            </ProtectedRoute>
          }
        />
          <Route
            path="/photomanagement" 
            element={
              <ProtectedRoute>
                <PhotoManagement />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/photoreviewobmexpert" 
            element={
              <ProtectedRoute>
                <PhotoReviewOBMExpert />
              </ProtectedRoute>
            }
          />
          <Route
            path="/audiobuzzmanagement" 
            element={
              <ProtectedRoute>
                <AudioBuzzManagement />
              </ProtectedRoute>
            }
          />
           <Route
            path="/audioReviewRecord" 
            element={
              <ProtectedRoute>
                <ReviewRecordTable />
              </ProtectedRoute>
            }
          />
          <Route
            path="/audioissueVisualization" 
            element={
              <ProtectedRoute>
                <AudioIssueVisaualization/>
              </ProtectedRoute>
            }
          />

            <Route
            path="/importData" 
            element={
              <ProtectedRoute>
                <ImportData/>
              </ProtectedRoute>
            }
          />
          <Route
            path="/audioSpectrogram" 
            element={
              <ProtectedRoute>
                <AudioSpectrogram/>
              </ProtectedRoute>
            }
          />
          <Route
            path="/AI-ODS" 
            element={
              <ProtectedRoute>
                <AIODSImageViewer/>
              </ProtectedRoute>
            }
          />

        {/* **Mura Labeling Routes** */}
        <Route
          path="/mura-labeling"
          element={
            <ProtectedRoute requiredPermission="LLMuraSpotLineBandIssueLabeling">
              <ProductInfo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/upload-image"
          element={
            <ProtectedRoute requiredPermission="LLMuraSpotLineBandIssueLabeling">
              <UploadPhoto />
            </ProtectedRoute>
          }
        />
        <Route
          path="/muralabeling"
          element={
            <ProtectedRoute requiredPermission="LLMuraSpotLineBandIssueLabeling">
              <MuraLabeling />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mark-defect-region"
          element={
            <ProtectedRoute requiredPermission="LLMuraSpotLineBandIssueLabeling">
              <MarkDefectRegion />
            </ProtectedRoute>
          }
        />
        <Route
          path="/mura-root-cause-labeling"
          element={
            <ProtectedRoute requiredPermission="LLMuraSpotLineBandIssueLabeling">
              <MuraRootCauseLabeling />
            </ProtectedRoute>
          }
        />
        <Route
          path="root-cause-details"
          element={
            <ProtectedRoute requiredPermission="LLMuraSpotLineBandIssueLabeling">
              <MuraRootCauseDetail />
            </ProtectedRoute>
          }
        />

        {/* **Issue Detection Routes** */}
        <Route
          path="/productinfodetection"
          element={
            <ProtectedRoute requiredPermission="MuraSpotLineBandIssueDetection">
              <ProductInfoDetection />
            </ProtectedRoute>
          }
        />
        <Route
          path="/upload-image-detection"
          element={
            <ProtectedRoute requiredPermission="MuraSpotLineBandIssueDetection">
              <UploadImage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agree-judgement"
          element={
            <ProtectedRoute requiredPermission="MuraSpotLineBandIssueDetection">
              <AgreeJudgement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/disagree-judgement"
          element={
            <ProtectedRoute requiredPermission="MuraSpotLineBandIssueDetection">
              <DisagreeJudgement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Re-Labeling"
          element={
            <ProtectedRoute requiredPermission="MuraSpotLineBandIssueDetection">
              <ReLabeling />
            </ProtectedRoute>
          }
        />
        <Route
          path="/MarkReLabeling"
          element={
            <ProtectedRoute requiredPermission="MuraSpotLineBandIssueDetection">
              <MarkRelabelingRegion />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Issue-Rootcause"
          element={
            <ProtectedRoute requiredPermission="MuraSpotLineBandIssueDetection">
              <IssueRootCauseLabeling />
            </ProtectedRoute>
          }
        />
        <Route
          path="/Root-Issuedetail"
          element={
            <ProtectedRoute requiredPermission="MuraSpotLineBandIssueDetection">
              <IssueRootCauseDetail/>
            </ProtectedRoute>
          }
        />

        {/* **Audio Analysis Routes**
        <Route
          path="/audio-analysis"
          element={
            <ProtectedRoute requiredPermission="AudioIssueVisualization">
              <AudioAnalysis />
            </ProtectedRoute>
          }
        />
        <Route
          path="/coming-soon-aid"
          element={
            <ProtectedRoute requiredPermission="AudioIssueVisualization">
              <ComingSoonAID />
            </ProtectedRoute>
          }
        /> */}


          {/* **Audio Analysis Routes** */}
        <Route
          path="/audio-calibaration"
          element={
            <ProtectedRoute requiredPermission="AudioIssueVisualization">
              <AudioCalibrationTool />
            </ProtectedRoute>
          }
        />
         <Route
          path="/audio-recording"
          element={
            <ProtectedRoute requiredPermission="AudioIssueVisualization">
              <Calibration />
            </ProtectedRoute>
          }
        />
        <Route
          path="/audiobuzz-detection"
          element={
            <ProtectedRoute requiredPermission="AudioIssueVisualization">
              <AudioBuzzDetection/>
            </ProtectedRoute>
          }
        />
        <Route
          path="/audio-verification"
          element={
            <ProtectedRoute requiredPermission="AudioIssueVisualization">
              <AudioVerification/>
            </ProtectedRoute>
          }
        />

        {/* **Statistics Routes** */}
        <Route
          path="/statistics-analysis"
          element={
            <ProtectedRoute requiredPermission="StatisticsAndAnalysis">
              <StatisticsAndAnalysis />
            </ProtectedRoute>
          }
        />
        <Route
          path="/photo-gallery"
          element={
            <ProtectedRoute requiredPermission="StatisticsAndAnalysis">
              <DefectPhotos/>
            </ProtectedRoute>
          }
        />
        <Route
          path="/photo-review"
          element={
            <ProtectedRoute requiredPermission="StatisticsAndAnalysis">
              <PhotoReview/>
            </ProtectedRoute>
          }
        />
        {/* **Hardwarechange route** */}

        <Route
          path="/hardware-change"
          element={
            <ProtectedRoute requiredPermission="HWChangeVerificationAssessment">
              <HWChangeVerification />
            </ProtectedRoute>
          }
        />
         <Route
          path="/assessment/:tab/:item"
          element={
            <ProtectedRoute requiredPermission="HWChangeVerificationAssessment">
              <AssessmentDetail />
            </ProtectedRoute>
          }
        />
         <Route
          path="/import-change-list"
          element={
            <ProtectedRoute requiredPermission="HWChangeVerificationAssessment">
              <ImportChangeList />
            </ProtectedRoute>
          }
        />
          <Route
          path="/verification-review"
          element={
            <ProtectedRoute requiredPermission="HWChangeVerificationAssessment">
              <VerificationReview/>
            </ProtectedRoute>
          }
        />

        <Route
          path="/certification-overview"
          element={
            <ProtectedRoute requiredPermission="HWChangeVerificationAssessment">
              <Certificationoverview/>
            </ProtectedRoute>
          }
        />

                  <Route
          path="/certification-details"
          element={
            <ProtectedRoute requiredPermission="HWChangeVerificationAssessment">
              <Certificationdetails/>
            </ProtectedRoute>
          }
        />
        <Route
          path="/light-leakage-product-info"
          element={
            <ProtectedRoute requiredPermission="LLMuraSpotLineBandIssueLabeling">
              <LLProductInfoInput />
            </ProtectedRoute>
          }
        />
        <Route
          path="/light-leakage-detector-camera"
          element={
            <ProtectedRoute requiredPermission="LLMuraSpotLineBandIssueLabeling">
              <LLDetectorCamera />
            </ProtectedRoute>
          }
        />
        <Route
          path="/light-leakage-labeling"
          element={
            <ProtectedRoute requiredPermission="LLMuraSpotLineBandIssueLabeling">
              <LightLeakageLabeling />
            </ProtectedRoute>
          }
        />
        <Route
          path="/light-leakage-Inspection"
          element={
            <ProtectedRoute requiredPermission="LLMuraSpotLineBandIssueLabeling">
              <FullscreenInspectionView />
            </ProtectedRoute>
          }
        />
        <Route
          path="/light-leakage-root-cause"
          element={
            <ProtectedRoute requiredPermission="LLMuraSpotLineBandIssueLabeling">
              <LightLeakageRootCauseLabeling />
            </ProtectedRoute>
          }
        />

        <Route
          path="/performance-input"
          element={
            <ProtectedRoute>
              <ProductInfoInput />
            </ProtectedRoute>
          }
        />
        <Route
          path="/performance-recording"
          element={
            <ProtectedRoute>
              <PerformanceRecording />
            </ProtectedRoute>
          }
        />
         <Route
          path="/Certification"
          element={
           <ProtectedRoute requiredPermission="Certification">
              <Certification/>
            </ProtectedRoute>
          }
        />
         <Route
          path="/monitor-control-table"
          element={
            <ProtectedRoute requiredPermission="Certification">
              <MonitorControlTable/>
            </ProtectedRoute>
          }
        />
         <Route path="/sw-change-verification" 
        element={<SWChangeVerificationAssessment />} 
        />
        <Route path="/project-reporting" 
        element={<ProjectReportingHub />} 
        />
        <Route path="/vendor-capability" 
        element={<VendorCapability />} 
        />
      </Routes>
    </HashRouter>
      </AudioDataProvider>
    </AssessmentProvider> 
    </GlobalProvider>
    </LanguageProvider>
  );
}

export default App;